var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 30,
    viewBox: "0 0 101 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8098_22114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.2358 30H3.73984C1.64553 30 0 28.275 0 26.25V3.75C0 1.65 1.72033 0 3.73984 0H97.2358C99.3301 0 100.976 1.725 100.976 3.75V26.25C100.976 28.35 99.3301 30 97.2358 30Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9365 16.3499C49.1413 16.3499 47.7202 17.6999 47.7202 19.5749C47.7202 21.3749 49.1413 22.7999 50.9365 22.7999C52.7316 22.7999 54.1527 21.4499 54.1527 19.5749C54.1527 17.6249 52.7316 16.3499 50.9365 16.3499ZM50.9365 21.4499C49.9641 21.4499 49.1413 20.6249 49.1413 19.4999C49.1413 18.3749 49.9641 17.5499 50.9365 17.5499C51.9088 17.5499 52.7316 18.2999 52.7316 19.4999C52.7316 20.6249 51.9088 21.4499 50.9365 21.4499ZM43.9804 16.3499C42.1852 16.3499 40.7641 17.6999 40.7641 19.5749C40.7641 21.3749 42.1852 22.7999 43.9804 22.7999C45.7755 22.7999 47.1966 21.4499 47.1966 19.5749C47.1966 17.6249 45.7755 16.3499 43.9804 16.3499ZM43.9804 21.4499C43.008 21.4499 42.1852 20.6249 42.1852 19.4999C42.1852 18.3749 43.008 17.5499 43.9804 17.5499C44.9527 17.5499 45.7755 18.2999 45.7755 19.4999C45.7755 20.6249 44.9527 21.4499 43.9804 21.4499ZM35.6779 17.3249V18.6749H38.8942C38.8194 19.4249 38.5202 20.0249 38.1462 20.3999C37.6974 20.8499 36.9495 21.3749 35.6779 21.3749C33.6584 21.3749 32.1625 19.7999 32.1625 17.7749C32.1625 15.7499 33.7332 14.1749 35.6779 14.1749C36.7251 14.1749 37.5478 14.6249 38.1462 15.1499L39.1186 14.1749C38.2958 13.4249 37.2487 12.8249 35.7527 12.8249C33.06 12.8249 30.7413 15.0749 30.7413 17.7749C30.7413 20.4749 33.06 22.7249 35.7527 22.7249C37.2487 22.7249 38.2958 22.2749 39.1934 21.2999C40.0909 20.3999 40.3901 19.1249 40.3901 18.1499C40.3901 17.8499 40.3901 17.5499 40.3153 17.3249H35.6779V17.3249ZM69.6356 18.3749C69.3365 17.6249 68.5885 16.3499 66.943 16.3499C65.2974 16.3499 63.9511 17.6249 63.9511 19.5749C63.9511 21.3749 65.2974 22.7999 67.0926 22.7999C68.5137 22.7999 69.4113 21.8999 69.7104 21.3749L68.6633 20.6249C68.2893 21.1499 67.8405 21.5249 67.0926 21.5249C66.3446 21.5249 65.8958 21.2249 65.5218 20.5499L69.7852 18.7499L69.6356 18.3749ZM65.2974 19.4249C65.2974 18.2249 66.2698 17.5499 66.943 17.5499C67.4665 17.5499 67.9901 17.8499 68.1397 18.2249L65.2974 19.4249ZM61.782 22.4999H63.2031V13.1249H61.782V22.4999ZM59.5381 17.0249C59.1641 16.6499 58.5657 16.2749 57.8178 16.2749C56.247 16.2749 54.7511 17.6999 54.7511 19.4999C54.7511 21.2999 56.1722 22.6499 57.8178 22.6499C58.5657 22.6499 59.1641 22.2749 59.4633 21.8999H59.5381V22.3499C59.5381 23.5499 58.8649 24.2249 57.8178 24.2249C56.995 24.2249 56.3966 23.6249 56.247 23.0999L55.0503 23.6249C55.4243 24.4499 56.3218 25.4999 57.8926 25.4999C59.5381 25.4999 60.8844 24.5249 60.8844 22.1999V16.4999H59.5381V17.0249V17.0249ZM57.8926 21.4499C56.9202 21.4499 56.0974 20.6249 56.0974 19.4999C56.0974 18.3749 56.9202 17.5499 57.8926 17.5499C58.8649 17.5499 59.6129 18.3749 59.6129 19.4999C59.6129 20.6249 58.8649 21.4499 57.8926 21.4499ZM76.143 13.1249H72.7771V22.4999H74.1982V18.9749H76.143C77.7137 18.9749 79.2096 17.8499 79.2096 16.0499C79.2096 14.2499 77.7137 13.1249 76.143 13.1249ZM76.2178 17.6249H74.1982V14.3999H76.2178C77.2649 14.3999 77.8633 15.2999 77.8633 15.9749C77.7885 16.7999 77.1901 17.6249 76.2178 17.6249ZM84.8194 16.2749C83.7722 16.2749 82.7251 16.7249 82.3511 17.6999L83.6226 18.2249C83.9218 17.6999 84.3706 17.5499 84.8942 17.5499C85.6422 17.5499 86.3153 17.9999 86.3901 18.7499V18.8249C86.1657 18.6749 85.5674 18.4499 84.969 18.4499C83.6226 18.4499 82.2763 19.1999 82.2763 20.5499C82.2763 21.8249 83.3982 22.6499 84.595 22.6499C85.5674 22.6499 86.0161 22.1999 86.3901 21.7499H86.4649V22.4999H87.8113V18.8999C87.6617 17.2499 86.3901 16.2749 84.8194 16.2749ZM84.6698 21.4499C84.221 21.4499 83.5478 21.2249 83.5478 20.6249C83.5478 19.8749 84.3706 19.6499 85.0438 19.6499C85.6421 19.6499 85.9413 19.7999 86.3153 19.9499C86.1657 20.8499 85.4178 21.4499 84.6698 21.4499ZM92.5235 16.4999L90.9527 20.5499H90.8779L89.2324 16.4999H87.7365L90.2048 22.1999L88.7836 25.3499H90.2048L94.0194 16.4999H92.5235V16.4999ZM79.9576 22.4999H81.3787V13.1249H79.9576V22.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77868 5.62537C7.55429 5.85037 7.47949 6.22537 7.47949 6.67537V23.2504C7.47949 23.7004 7.62909 24.0754 7.85348 24.3004L7.92827 24.3754L17.2031 15.0754V15.0004V14.9254L7.77868 5.62537Z",
    fill: "url(#paint0_linear_8098_22114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1952 18.2252L17.1285 15.1502V15.0002V14.9252L20.1952 11.8502L20.27 11.9252L23.935 14.0252C24.9822 14.6252 24.9822 15.6002 23.935 16.2002L20.1952 18.2252Z",
    fill: "url(#paint1_linear_8098_22114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2699 18.1504L17.1284 15.0004L7.77881 24.3754C8.15279 24.7504 8.67637 24.7504 9.34954 24.4504L20.2699 18.1504Z",
    fill: "url(#paint2_linear_8098_22114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2699 11.8504L9.34954 5.62539C8.67637 5.25039 8.15279 5.32539 7.77881 5.70039L17.1284 15.0004L20.2699 11.8504Z",
    fill: "url(#paint3_linear_8098_22114)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.1954 18.0754L9.34991 24.2254C8.75153 24.6004 8.22796 24.5254 7.85397 24.2254L7.77917 24.3004L7.85397 24.3754C8.22796 24.6754 8.75153 24.7504 9.34991 24.3754L20.1954 18.0754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M7.77917 24.2252C7.55469 24.0002 7.47986 23.6252 7.47986 23.1752V23.2502C7.47986 23.7002 7.62951 24.0752 7.85399 24.3002V24.2252H7.77917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M23.9349 15.9754L20.1951 18.0754L20.2699 18.1504L23.9349 16.0504C24.4585 15.7504 24.6829 15.3754 24.6829 15.0004C24.6829 15.3754 24.3837 15.6754 23.9349 15.9754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M9.34941 5.7002L23.9348 14.0252C24.3836 14.3252 24.6827 14.6252 24.6827 15.0002C24.6827 14.6252 24.4584 14.2502 23.9348 13.9502L9.34941 5.6252C8.30226 5.0252 7.47949 5.4752 7.47949 6.6752V6.7502C7.47949 5.6252 8.30226 5.1002 9.34941 5.7002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4893 10.7256H30.9657V9.22555H31.4145C31.7885 8.92555 32.0129 8.32555 32.0129 7.50055V5.25055H35.0047V9.22555H35.5283V10.7256H35.0047V9.75055H31.5641V10.7256H31.4893ZM32.5364 7.50055C32.5364 8.17555 32.3868 8.77555 32.0876 9.22555H34.3316V5.77555H32.4616V7.50055H32.5364Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182857,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9413 9.14981C39.4925 9.59981 38.9689 9.82481 38.2957 9.82481C37.6226 9.82481 37.099 9.59981 36.6502 9.14981C36.2014 8.69981 35.9771 8.17481 35.9771 7.49981C35.9771 6.82481 36.2014 6.29981 36.6502 5.84981C37.099 5.3998 37.6226 5.1748 38.2957 5.1748C38.9689 5.1748 39.4925 5.3998 39.9413 5.84981C40.3901 6.29981 40.6144 6.82481 40.6144 7.49981C40.6144 8.17481 40.3901 8.69981 39.9413 9.14981ZM37.099 8.77481C37.3982 9.07481 37.847 9.29981 38.2957 9.29981C38.7445 9.29981 39.1933 9.14981 39.4925 8.77481C39.7917 8.47481 40.0161 8.02481 40.0161 7.49981C40.0161 6.97481 39.8665 6.52481 39.4925 6.22481C39.1933 5.92481 38.7445 5.6998 38.2957 5.6998C37.847 5.6998 37.3982 5.84981 37.099 6.22481C36.7998 6.52481 36.5754 6.97481 36.5754 7.49981C36.5754 8.02481 36.725 8.47481 37.099 8.77481Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182857,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5317 9.82481C42.8585 9.82481 42.335 9.59981 41.8862 9.14981C41.4374 8.69981 41.213 8.17481 41.213 7.49981C41.213 6.82481 41.4374 6.29981 41.8862 5.84981C42.335 5.3998 42.8585 5.1748 43.5317 5.1748C44.2049 5.1748 44.7285 5.3998 45.1772 5.9248L44.8033 6.2998C44.5041 5.9248 44.0553 5.6998 43.5317 5.6998C43.0081 5.6998 42.6342 5.84981 42.2602 6.22481C41.8862 6.52481 41.7366 6.97481 41.7366 7.49981C41.7366 8.02481 41.8862 8.47481 42.2602 8.77481C42.5594 9.07481 43.0081 9.29981 43.5317 9.29981C44.0553 9.29981 44.5041 9.07481 44.8781 8.62481L45.252 8.99981C45.0277 9.22481 44.8033 9.44981 44.5041 9.59981C44.2049 9.74981 43.9057 9.82481 43.5317 9.82481Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182857,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6453 9.75018H47.0469V5.77518H45.7754V5.25018H48.8421V5.77518H47.5705V9.75018H47.6453Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182857,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8063 5.25018L51.086 9.07518C50.8616 9.60018 50.4876 9.90018 50.0388 9.90018C49.8892 9.90018 49.7396 9.90018 49.59 9.82518L49.7396 9.30018C49.8144 9.37518 49.964 9.37518 50.0388 9.37518C50.1884 9.37518 50.2632 9.37518 50.338 9.30018C50.4128 9.22518 50.4876 9.15018 50.5624 9.00018L50.712 8.62518L49.2161 5.32518H49.8892L51.0112 7.87518L52.1331 5.25018H52.8063Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182857,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4795 9.75018V5.25018H56.6957V9.75018H56.0974V5.77518H54.0031V9.75018H53.4795Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182857,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7429 9.75018V5.25018H58.3413V7.20018H60.5852V5.25018H61.1836V9.75018H60.5852V7.72518H58.3413V9.75018H57.7429Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182857,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8959 9.14981C65.4471 9.59981 64.9235 9.82481 64.2503 9.82481C63.5772 9.82481 63.0536 9.59981 62.6048 9.14981C62.156 8.69981 61.9316 8.17481 61.9316 7.49981C61.9316 6.82481 62.156 6.29981 62.6048 5.84981C63.0536 5.3998 63.5772 5.1748 64.2503 5.1748C64.9235 5.1748 65.4471 5.3998 65.8959 5.84981C66.3446 6.29981 66.569 6.82481 66.569 7.49981C66.4942 8.17481 66.2698 8.69981 65.8959 9.14981ZM62.9788 8.77481C63.278 9.07481 63.7268 9.29981 64.1755 9.29981C64.6243 9.29981 65.0731 9.14981 65.3723 8.77481C65.6715 8.47481 65.8959 8.02481 65.8959 7.49981C65.8959 6.97481 65.7463 6.52481 65.3723 6.22481C65.0731 5.92481 64.6243 5.6998 64.1755 5.6998C63.7268 5.6998 63.278 5.84981 62.9788 6.22481C62.6796 6.52481 62.4552 6.97481 62.4552 7.49981C62.4552 8.02481 62.6796 8.47481 62.9788 8.77481Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182857,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8882 9.75018V5.25018H70.5337C70.9077 5.25018 71.2069 5.40018 71.4313 5.62518C71.6557 5.85018 71.8053 6.15018 71.8053 6.45018C71.8053 6.67518 71.7305 6.82518 71.6557 7.05018C71.5809 7.20018 71.4313 7.35018 71.2069 7.42518C71.4313 7.50018 71.5809 7.65018 71.7305 7.80018C71.88 7.95018 71.9548 8.17518 71.9548 8.47518C71.9548 8.85018 71.8052 9.15018 71.5809 9.37518C71.2817 9.60018 70.9825 9.75018 70.6085 9.75018H68.8882ZM69.4866 7.20018H70.5337C70.7581 7.20018 70.9077 7.12518 71.0573 6.97518C71.2069 6.82518 71.2817 6.67518 71.2817 6.52518C71.2817 6.37518 71.1321 6.15018 71.0573 6.00018C70.9077 5.85018 70.7581 5.77518 70.5337 5.77518H69.4866V7.20018V7.20018ZM69.4866 9.22518H70.6833C70.9077 9.22518 71.0573 9.15018 71.2069 9.00018C71.3565 8.85018 71.4313 8.70018 71.4313 8.47518C71.4313 8.32518 71.3565 8.10018 71.2069 7.95018C71.0573 7.80018 70.9077 7.72518 70.6833 7.72518H69.5614V9.22518H69.4866Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.182857,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8098_22114",
    x1: 16.3052,
    y1: 6.53272,
    x2: 3.71845,
    y2: 19.0854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8098_22114",
    x1: 25.307,
    y1: 15.0013,
    x2: 7.20855,
    y2: 15.0013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8098_22114",
    x1: 18.5697,
    y1: 16.7225,
    x2: 1.501,
    y2: 33.7449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8098_22114",
    x1: 5.45802,
    y1: 0.132613,
    x2: 13.0799,
    y2: 7.7338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8098_22114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100.976,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.9c1c2e736155012a1280ff61277e1b2e.svg";
export { ForwardRef as ReactComponent };